module.exports = __webpack_public_path__ + "media/images/about-31070b31ba3a0d7f6dca8b69ddf44256.png";